import type { SVGProps } from 'react'
const SvgSyDoughnut = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M15.2 10.9c-.2-.5-.4-.9-.8-1.3s-.8-.6-1.3-.8V.7c2.7.3 5 1.3 6.9 3.2s3 4.2 3.2 6.9h-8.1zm-4.3 12.4C8 23 5.6 21.8 3.6 19.6 1.7 17.4.7 14.9.7 12s1-5.5 2.9-7.6C5.5 2.2 8 1 10.9.7v8c-.7.2-1.2.7-1.6 1.3s-.6 1.2-.6 2 .2 1.4.6 1.9 1 1 1.6 1.2v8.1zm2.3 0v-8.1c.5-.2.9-.4 1.3-.8s.6-.8.8-1.3h8.1c-.3 2.7-1.3 5-3.2 6.9s-4.2 3-6.9 3.2z" />
	</svg>
)
export default SvgSyDoughnut
